// Layout.jsx
import React, { useContext } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import NavMenu from './NavMenu';
import TopBar from './TopBar';
import { MOBILE_TOPBAR_HEIGHT } from './NavMenu';
import { AuthContext } from '../contexts/AuthContext';
import { ambientBackground } from '../styles/glass';

const Layout = ({ children, fullBleed = false }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { role } = useContext(AuthContext);

    return (
        <Box sx={{ display: 'flex', width: '100%', height: '100vh' }}>
            <NavMenu />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    backgroundColor: '#f8fafc',
                    background: ambientBackground,
                    backgroundAttachment: 'fixed',
                    p: 0,
                    height: '100vh',
                    minWidth: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    transition: 'margin-left 0.4s ease',
                    pt: isMobile ? `${MOBILE_TOPBAR_HEIGHT}px` : 0,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <TopBar />
                <Box sx={{ flexGrow: 1, p: fullBleed ? 0 : (isMobile ? 1 : 3), overflowY: 'auto' }}>
                    {children}
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;
